import van from "vanjs-core"
import {route, url} from "./components/Router";
import PrimaryButton from "./components/PrimaryButton";
import { NavBar } from "./components/NavBar";
import { isSignedIn } from "./globals";

const {div, button, a, t, h1} = van.tags;

const NotFoundPage = () => {
  return div(
    {class: "flex flex-col h-full p-5"},
    NavBar(),
    div(
      {class: "flex flex-col w-full h-full justify-center items-center gap-10"},
      h1(
        {class: "font-rope font-semibold text-4xl"},
        "Page Not Found"
      ),
      
      PrimaryButton({
        href: "/",
        text: "Back"
      })
    ),
  )
}

export default NotFoundPage;